<template>
<div>
    <div class="card-body">
        <b-row>
            <b-col md="12">
                <div class="pull-right">
                    <b-button v-b-modal.modalPriceAgreements variant="themecolor" size="sm" @click.stop="loadModal(null)"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('buttons.toevoegen')}}</b-button>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12">
                <b-table class="table-hover"
                         show-empty
                         :items="priceAgreementsCustomer"
                         :fields="fields" 
                         v-if="priceAgreementsCustomer"
                         :empty-text="getEmptyText(count)"
                         :busy="count == -1">
                    <template v-slot:cell(name)="data">{{ data.item.priceAgreement.name }}</template>
                    <template v-slot:cell(priceAgreementType)="data">{{ data.item.priceAgreement.priceAgreementType | agreementType }}</template>
                    <template v-slot:cell(price)="data">{{ data.item.priceAgreement.price | currency }}</template>

                    <template v-slot:cell(actions)="row">
                        <b-button v-b-modal.modalPriceAgreements variant="themecolor" size="sm" @click.stop="loadModal(row.item)">
                            <i class="fa fa-edit" aria-hidden="true"></i>
                        </b-button>
                        <delete title="Prijsafspraak" 
                            :noRedirect="true" 
                            :hideText="true" 
                            :id="row.item.id" 
                            namespace="fm" 
                            resource="price-agreements-customer" />
                    </template>
                    <template v-slot:table-busy>
                        <PreLoader/>
                    </template>
                </b-table>
            </b-col>
        </b-row>
    </div>
    <!-- Modal Component -->
    <b-modal id="modalPriceAgreements" ref="priceagreements" :title="`${$t('priceagreements.prijsafspraak')} ${command.id ? $t('buttons.bewerken') : $t('buttons.aanmaken')}`" hide-footer centered :cancel-title="$t('buttons.annuleren')" ok-variant="themecolor" :ok-title="$t('buttons.opslaan')">
        <b-form @submit="onSubmit" autocomplete="off">
            <!-- Form content -->
            <b-form-group label-cols :label="$t('priceagreements.prijsafspraak')" label-for="price_agreement_id">
                <b-form-select id="price_agreement_id" v-model="command.priceAgreementId" :disabled="command.id != ''">
                    <option value="">{{$t('klanten.selecteereenprijsafspraak')}}</option>
                    <option :key="index" :value="fmPriceAgreement.id" v-for="(fmPriceAgreement, index) in fmPriceAgreements">{{ fmPriceAgreement.name }} - {{ fmPriceAgreement.price | currency}}</option>
                </b-form-select>
                <validation element="price_agreement_id" />
            </b-form-group>
            <b-form-group label-cols :label="$t('carpetline.aantal')" label-for="quantity">
                <vue-numeric currency="" separator="." v-bind:precision="0" v-model="command.quantity"  class="form-control" id="quantity" />
                <validation element="quantity" />
            </b-form-group>
            <!-- Form content -->
            <hr />
            <!-- Submit controls -->
            <b-row>
                <b-col md="12">
                    <b-button @click="$refs.priceagreements.hide()" variant="secondary">{{$t('buttons.annuleren')}}</b-button>
                    <b-button type="submit" variant="themecolor">{{$t('buttons.opslaan')}}</b-button>
                </b-col>
            </b-row>
            <!-- Submit controls -->
        </b-form>
    </b-modal>
    <!-- Modal Component -->
</div>
</template>

<script>
//Import store
import {
    mapGetters,
    mapActions
} from "vuex";

//Import command
import Command from "./command";
import PreLoader from '@/components/root/Preloader';
import { getEmptyText } from '@/views/root/GetMessageTextHelper';

export default {
    name: "price-agreements",
    components: {PreLoader},
    data() {
        return {
            command: {},
            title: "Prijsafspraken",
            count: -1,
        };
    },
    computed: {
        fields() { 
            return [{
                    key: 'name',
                    label: this.$i18n.t('datatables.naam'),
                    sortable: true
                },
                {
                    key: 'priceAgreementType',
                    label: this.$i18n.t('datatables.type'),
                    sortable: true
                },
                {
                    key: 'price',
                    label: this.$i18n.t('datatables.tarief'),
                    sortable: true
                },
                {
                    key: 'quantity',
                    label: this.$i18n.t('carpetline.aantal'),
                    sortable: true,
                    class: 'text-center'
                },
                {
                    key: 'actions',
                    label: this.$i18n.t('datatables.acties')
                }
            ]
        },
        ...mapGetters ('fm', ['priceAgreementsCustomer', 'priceAgreementsTypes']),
        ...mapGetters({
            fmPriceAgreements: 'fm/priceAgreements'
        }),
    },
    methods: {
        ...mapActions('fm', ['all', 'create', 'update', 'delete']),
        loadModal(item) {
            let vm = this;
            vm.$store.dispatch('errors/clearErrors');
            vm.command = new Command(item);
        },
        onSubmit(event) {
            event.preventDefault();
            let vm = this;
            let payload = {
                resource: "price-agreements-customer",
                params: vm.command
            };

            let action = vm.command.id ? vm.update(payload) : vm.create(payload);
            action.then(() => {
                vm.$store.dispatch('fm/all', {
                    resource: 'price-agreements-customer'
                });
                vm.$refs.priceagreements.hide();
            });
        },
        getEmptyText,
         
    },
    created() {
        var vm = this;
        vm.all({
            resource: 'price-agreements-customer'
        })
        .then((data) => {
            vm.count = data.result.length;
        });
        vm.$store.dispatch('fm/all', {
            resource: 'price-agreements'
        });
    }
};
</script>
